const ApiUrl = '//static.kipelov.ru';
export default ApiUrl;
